// List of inappropriate 3-letter words to filter
const INAPPROPRIATE_WORDS = [
    // Profanity and offensive terms
    'ASS', 'FAG', 'FUK', 'FUC', 'SEX', 'SUX', 'SUK', 'TIT', 'TWT', 'WTF',
    // Hate speech and discriminatory terms
    'NAZ', 'KKK', 'RAC',
    // Violence-related
    'KIL', 'MUR', 'DIE', 'BOM', 'GUN', 'AXE',
    // Drug-related
    'DRG', 'DRU', 'COK', 'CRK', 'HER', 'LSD', 'MDM', 'XTC',
    // Medical/STD-related (common inappropriate usage)
    'STD', 'AID', 'HIV', 'GON', 'SYF',
    // Other inappropriate terms
    'PIS', 'PEE', 'POO', 'SHI', 'FEC', 'VOM', 'PUK'
].map(word => word.toUpperCase());

const isInappropriateName = (value) => {
    if (!value || typeof value !== 'string') return false;
    const upperValue = value.toUpperCase().trim();
    return INAPPROPRIATE_WORDS.includes(upperValue);
};

const isValidHighScoreUser = (value) => {
    if (!value || typeof value !== 'string') return false;
    const upperValue = value.toUpperCase().trim();
    // Check format: exactly 3 uppercase letters
    if (!new RegExp("^[A-Z]{3}$").test(upperValue)) return false;
    // Check if it's the reserved name
    if (upperValue === 'PAT') return false;
    // Check if it's inappropriate
    if (isInappropriateName(upperValue)) return false;
    return true;
};

module.exports = { isValidHighScoreUser, isInappropriateName }
